/**
 * @file automatically generated from MApp.Data.LegendType
 */

export enum LegendType {
    Tree = 1,
    Simple = 2,
    Advanced = 3
}
